"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
const xss_1 = __importDefault(require("xss"));
exports.defaultOptions = {
    whiteList: {
        div: [],
        p: [],
        br: [],
        em: [],
        u: [],
        ul: [],
        li: [],
        strong: [],
        span: [],
        i: [],
        b: [],
        a: ['href', 'rel', 'target'],
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script'],
};
class HtmlSanitizer {
    validateType(value) {
        return /<\/?[a-z][\s\S]*>/i.test(value);
    }
    sanitize(html, options = {}) {
        return (0, xss_1.default)(html, { ...exports.defaultOptions, ...options });
    }
}
exports.default = new HtmlSanitizer();
